import {createTheme} from '@mui/material/styles';

/**
 * 共通テーマ(Material-UI使用)
 */
const CommonTheme = createTheme({
  palette: {
    primary: {
      main: '#4F89C6',
      dark: '#001a37',
    },
    secondary: {
      main: '#EA5433',
    },
  },
  breakpoints: {
    values: {
      lg: 1366,
    },
  },
  menu: {
    width: 330,
    fontSize: '16pt',
  },
  chubuPalette: {
    primary: {
      main: '#4F89C6',
      dark: '#001a37',
      light: '#99C5F7',
    },
    secondary: {
      main: '#E60012',
    },
  },
  mouse: {
    color: '#E0E0E0',
  },
});

export default CommonTheme;
